import React, { useState, useEffect } from 'react';
import API from '../utils/gasClient';
import { TicketBatch } from '../components/TicketBatch';
import { Loading } from '../components/Loading';

export const TicketBatchContainer = ({ event }) => {
  const [lotes, setLotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLotes = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Passa o eventId para buscar da planilha correta
        const lotesData = await API.getSpreadsheetData('lotes', event?.eventId);
        
        // Ordena os lotes por data de fim
        const lotesOrdenados = lotesData.sort((a, b) => {
          return new Date(a.dataFim) - new Date(b.dataFim);
        });

        setLotes(lotesOrdenados);
        setLoading(false);
      } catch (err) {
        console.error('❌ Erro ao buscar lotes:', err);
        setError('Não foi possível carregar os dados dos lotes. Por favor, atualize a página ou tente novamente mais tarde.');
        setLoading(false);
      }
    };

    if (event?.eventId) {
      fetchLotes();
    }
  }, [event]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <div className="text-red-600 p-4 text-center">
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 px-6 py-2 bg-primary text-white rounded-full hover:bg-primary-hover transition-colors duration-300"
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  return <TicketBatch lotes={lotes} />;
}; 